import React, { useEffect, useState } from 'react'
import useSWR from 'swr'
import { basicFetcher } from '../../utils/api/swr-fetcher'
import { type PortfolioBalanceData } from '../../models/asset/asset-types'
import StackColumnLayout from '../../layouts/stack-column-layout'
import BalanceDataGrid from './balance-data-grid'

const MultiBalanceTestDataGrid: React.FC = () => {
  const [portfolios, setPortfolios] = useState<string[]>([])
  const { data, error } = useSWR<PortfolioBalanceData, boolean>(
    process.env.REACT_APP_API_ASSET,
    basicFetcher,
    {
      shouldRetryOnError: true,
      refreshInterval: 5000
    }
  )

  useEffect(() => {
    if (error === true || data === undefined) {
      setPortfolios([])
    } else {
      setPortfolios(Object.keys(data).filter(key => key !== 'timestamp'))
    }
  }, [data, error])

  return (
    <StackColumnLayout>
      {
        portfolios.map(portfolio => <BalanceDataGrid key={`${portfolio}-balance-data-grid`} portfolio={portfolio}/>)
      }
    </StackColumnLayout>
  )
}

export default MultiBalanceTestDataGrid
